<template>
  <!-- <HelloWorld /> -->
  <div>
    <v-container>
      <v-layout row v-if="participantById">
        <v-flex xs12>
          <h3>{{participantById.fullName}}</h3>
          <v-divider></v-divider>
          <div v-for="evaluation in evaluations" :key="evaluation.id">
            <p>{{evaluation.id}}</p>
            <p>{{evaluation.observationsByEvaluationId.totalCount}} observations in this evaluation</p>
            <v-divider></v-divider>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

  import {participantDetailQuery } from '@/graphql/participantQueries.gql'
  export default {
    components: {
    },
    apollo: {
      participantById:{
        query: participantDetailQuery,
        // Reactive parameters
        variables() {
          // Use vue reactive properties here
          return {
            id: this.participantId,
          }
        },
      }
    },
    computed:{
      evaluations (){
        var evals = []
        if (this.participantById){
          for(var i in this.participantById.participationsByParticipantId.nodes){
            var evaluation = this.participantById.participationsByParticipantId.nodes[i].evaluationByEvaluationId
            evals.push(evaluation)
          }
        }
        return evals
      }
    },
    data () {
      return {
        participantById:null,
      }
    },
    props:['participantId']
  }
</script>